<template>
  <section class="new" v-if="getEditEvent || getEditPlace">
    <div class="new-type new-type_edit">
      <div class="new-type__item" v-if="getEditEvent">
        <p>Редактирование мероприятия "{{ getEditEvent.title}}"</p>
      </div>
      <div class="new-type__item" v-if="getEditPlace">
        <p>Редактирование места "{{ getEditPlace.title}}"</p>
      </div>
    </div>
    <edit-event :event="getEditEvent" v-if="getEditEvent" />
    <edit-place :place="getEditPlace" v-if="getEditPlace" />

    <div class="new-close" @click="clearEdits()">
      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 224.512 224.512" style="enable-background:new 0 0 224.512 224.512;" xml:space="preserve">
<g>
  <polygon points="224.507,6.997 217.521,0 112.256,105.258 6.998,0 0.005,6.997 105.263,112.254 0.005,217.512 6.998,224.512 112.256,119.24 217.521,224.512 224.507,217.512 119.249,112.254 	"/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
        </svg>
    </div>
  </section>
</template>

<script lang="ts">
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFlag } from '@fortawesome/free-regular-svg-icons';
import EditEvent from './EditEvent.vue';
import EditPlace from './EditPlace.vue';

library.add(faFlag);

export default {
  name: 'Workplace',
  data: () => {
    return {
      type: 'event',
    };
  },
  components: {
    EditEvent,
    EditPlace
  },
  computed: {
        getEditEvent() {
          return this.$store.getters.getEditEvent
        },
        getEditPlace() {
          return this.$store.getters.getEditPlace
        },
    },
  methods: {
    changeState(element) {
      this.$store.dispatch('changeState', { element });
    },
    clearEdits() {
        this.$store.dispatch('editPlace', null)
        this.$store.dispatch('editEvent', null)
        this.$store.dispatch('clearSportsNew')
    }
  },
};
</script>
